import React, {useState, useEffect} from 'react';
import CloseIcon from './image/close/x.svg';
const LocalPopupContainer = (props) => {
  const [fadeType, setFadeType] = useState('null');

  useEffect(() => {
    if (props.showPopUp) {
      setFadeType('in');
    }
   
  }, [props.showPopUp]);

  return props.showPopUp ? (
    <div className={`local-wrapper-popup fade-${fadeType} ${props.className ? props.className : ''}`} role='dialog'>
      <div className='box-dialog'>
        <div className='box-header '>
          <button onClick={props.onClose} className='close-btn' style={{backgroundImage: CloseIcon.bg()}} ></button>
        </div>
        <div className='box-content'>{props.children}</div>
      </div>
      <div className={`background`} onMouseDown={props.onClose} />
    </div>
  ) : null;
};

export default LocalPopupContainer;
